import React from 'react';
import { RecoilRoot } from 'recoil';
import {App} from '../App';
import { StockServiceContextProvider } from '../../context/stock';
import { ThemeProvider } from '../../context/ThemeContext';
import {AuthProvider} from '../../context/authContext';
import { CustomerServiceContextProvider } from '../../context/customer';

export const Root: React.FC = () => {
  return (
    <RecoilRoot>
      <ThemeProvider>
        <AuthProvider>
          <CustomerServiceContextProvider>
            <StockServiceContextProvider>
              <App />
            </StockServiceContextProvider>
          </CustomerServiceContextProvider>
        </AuthProvider>
      </ThemeProvider>
    </RecoilRoot>
  );
};